<div class="container py-4 bulk-clone-page">
  <button class="btn btn-link text-decoration-none ps-0 mb-2" (click)="goBack()">
    <i class="bi bi-arrow-left me-1"></i> Back
  </button>

  <div class="card shadow">
    <div class="card-header">
      <h5 class="mb-0">Bulk Clone Planograms</h5>
    </div>
    <div class="card-body">
      <p class="text-muted">
        Clone the selected planograms into a single store and destination folder. Each clone is an
        independent copy and keeps its own merchandise category.
      </p>

      <div class="card mb-4">
        <div class="card-header fw-medium">
          Selected planograms ({{ planograms.length }})
        </div>
        <ul class="list-group list-group-flush selected-list">
          @for (planogram of planograms; track planogram.guid) {
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span>
                {{ planogram.storeName }} <span class="text-muted">|</span> {{ planogram.merchName }}
              </span>
              <small class="text-muted">{{ planogram.drops }} drops</small>
            </li>
          }
        </ul>
      </div>

      <form [formGroup]="bulkCloneForm" (ngSubmit)="submit()">
        <div class="mb-3">
          <label class="form-label">Target store <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            formControlName="store"
            [ngbTypeahead]="searchStores"
            [resultFormatter]="storeFormatter"
            [inputFormatter]="storeFormatter"
            [editable]="false"
            placeholder="Search for a store..." />
          <small class="text-muted">All selected planograms will be cloned into this store.</small>
        </div>

        <div class="mb-4">
          <label class="form-label">Destination folder</label>
          <select class="form-select" formControlName="folderId">
            <option value="">-- Default Folder --</option>
            @for (folder of flatFolders; track folder.id) {
              <option [value]="folder.id">{{ folder.name }}</option>
            }
          </select>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="goBack()" [disabled]="isSubmitting">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="bulkCloneForm.invalid || isSubmitting">
            @if (isSubmitting) {
              <span class="spinner-border spinner-border-sm me-1"></span> Cloning...
            } @else {
              <i class="bi bi-files me-1"></i> Clone {{ planograms.length }} Planogram(s)
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
